<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
        <Form ref="contratForm" v-slot="{ handleSubmit }" :validation-schema="modelSchema">
          <form @submit="handleSubmit(addModel)">
            <div class="row">
              <div class="col-md-12 mb-3">
                <div class="form-group mb-8 mb-sm-10 mb-md-15">
                  <label class="d-block text-black fw-semibold mb-5">
                    Contenu <span class="text-danger">*</span>
                  </label>
  
                  <Field name="contenu" v-slot="{ field, errors }">
                    <quill-editor
                      v-model="content"
                      :options="editorConfig"
                      @input="field.onChange($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </Field>
  
                  <ErrorMessage name="contenu" class="text-danger" />
                </div>
              </div>
            </div>
          </form>
        </Form>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { ref } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import * as Yup from 'yup';
  
  export default {
    name: "AddModelContrat",
    components: {
      Form,
      Field,
      ErrorMessage
    },
    setup() {
      const content = ref("<p>Bienvenue dans Quill !</p>");
  
      const modelSchema = Yup.object().shape({
        contenu: Yup.string().required('Observation is required'),
      });
  
      const editorConfig = {
        theme: "snow",
        modules: {
          toolbar: [
            [{ 'header': '1' }, { 'header': '2' },{ 'header': '3' }, { 'font': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ 'align': [] }],
            ['clean']
          ]
        }
      };
  
      const addModel = () => {
        console.log("Données envoyées :", content.value);
      };
  
      return { content, editorConfig, addModel, modelSchema };
    },
  };
  </script>
  
  <style>
  @import "~quill/dist/quill.snow.css";
  </style>
  